import { useState } from "react";
// import { useSelector } from "react-redux";

export default function Areas({ areas, selectArea, selectedArea, host }) {
  const AreaItem = ({ area }) => {
    // const selectedArea = useSelector((state) => state.servicesList.selectedArea);

    const iconImg = "//" + host + area.icon;
    const iconHover = "//" + host + area.icon_hover;
    const [icon, setIcon] = useState(iconImg);

    const hoverImage = (hover) => {
      if (hover) {
        setIcon(iconHover);
      } else {
        setIcon(iconImg);
      }
    };

    return (
      <div onClick={() => selectArea(area)} className={`col-6 col-lg-3`}>
        <div className="d-flex flex-column justify-content-center align-items-center services-area">
          <img
            src={selectedArea && area.slug === selectedArea ? iconHover : icon}
            alt={area.title}
            onMouseOver={() => {
              hoverImage(true);
            }}
            onMouseOut={() => {
              hoverImage(false);
            }}
          />
          <p className="h4 mt-2">{area.title}</p>
        </div>
      </div>
    );
  };
  return (
    <div className="row">
      {areas.map((area, index) => (
        <AreaItem area={area} key={`area_${index}`} />
      ))}
    </div>
  );
}
